


















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class NumberInput extends Vue {
  @Prop() value!: number;
  @Prop() min?: number;
  @Prop() max?: number;

  isNumber(event: KeyboardEvent) {
    const keyCode = event.keyCode ? event.keyCode : event.which;
    if (keyCode < 48 || keyCode > 57) {
      // 46 is dot
      event.preventDefault();
    }
  }

  setNumber(value: number | string) {
    let result = Number(value || 0);
    if (isNaN(result) || (typeof this.min === 'number' && value < this.min)) {
      result = this.min as number;
    } else if (typeof this.max === 'number' && value > this.max) {
      result = this.max;
    }

    this.$emit('input', result);

    this.$forceUpdate();
  }

  onFocus(event: FocusEvent) {
    const input = event.target as HTMLInputElement;
    input.select();
  }
}
